import { CircularProgress } from "@mui/material";
import { CenterContainer } from "components";
import { ENDPOINTS } from "config/constants";
import { useContextController } from "context";
import { login } from "context/actions";
import { useFetch, useTranslation } from "hooks";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { UserModel } from "types";

interface Data {
  user?: UserModel;
}

export default function Google() {
  const { response, error, callFetch } = useFetch<Data>("POST");
  const [, dispatch] = useContextController();
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const t = useTranslation();

  useEffect(() => {
    if (response && response.data && response.data.user) {
      login(response.data.user, dispatch);
      navigate("/");
    }
  }, [response, navigate, dispatch]);

  useEffect(() => {
    if (error) {
      enqueueSnackbar(error ? error?.message || JSON.stringify(error) : t["Failed to login with google"], {
        variant: "error"
      });
      navigate("/");
    }
  }, [error, t, navigate, enqueueSnackbar]);

  useEffect(() => {
    callFetch(ENDPOINTS.google + window.location.search).catch(console.error);
  }, [callFetch]);

  return (
    <CenterContainer>
      <CircularProgress color="success" />
    </CenterContainer>
  );
}
